import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router'
import { Select2OptionData } from 'ng2-select2';

import * as firebase from 'firebase/app';

@Component({
  selector: 'app-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.scss'],
  providers: [AngularFireAuth, AngularFireDatabase],
  animations: [
    trigger('flyInOut', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        style({transform: 'translateX(100%)'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({transform: 'translateX(-100%)'}))
      ])
    ])
  ]
})
export class SignupFormComponent implements OnInit {
  public statusSelect: Select2Options;
  public notificationSelect: Select2Options;
  public statusOptions: Array<Select2OptionData>;
  public notificationOptions: Array<Select2OptionData>;

  confirmationResult : any;
  currentState : any = {};
  currentUser : any;
  error : boolean = false;
  errorMessage : string;
  loading : boolean = false;
  moreOptions : boolean = false;
  profile : any = {
    avatarUrl: 'https://chispa-rural.firebaseapp.com/assets/img/avatar.png',
    gender: 'na',
  };
  recaptchaVerifier : any;
  social : boolean = false;
  states : Observable<any[]>;
  step = 1;
  user : any = {};
  verified : boolean = false;
  items : Observable<any[]>;

  constructor(private auth : AngularFireAuth, private router : Router, public db: AngularFireDatabase) { }

  ngOnInit() {
    this.statusSelect = {
      multiple: true,
      placeholder: 'Trabaja, estudia, etc.'
    }

    this.notificationSelect = {
      multiple: true,
      placeholder: 'Becas, Capacitaciones, etc.'
    }

    this.statusOptions = [
      { id: 'working', text: 'Trabaja' },
      { id: 'studying', text: 'Estudia' },
      { id: 'enterpreneur', text: 'Tiene una idea de negocio' },
      { id: 'study-work', text: 'Estudia y Trabaja' }
    ];

    this.notificationOptions = [
      {id: 'scolarships', text: 'Becas'},
      {id: 'workshops', text: 'Capacitaciones'},
      {id: 'employment', text: 'Empleo'},
      {id: 'discussion', text: 'Grupos de Discusión'},
      {id: 'more', text: 'Otro'}
    ]

    this.states = this.db.list('/states')
    .snapshotChanges()
    .map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });

    this.items = this.db.list('topics', ref => ref.orderByChild('isMain').equalTo(true))
      .snapshotChanges().map(changes => {
        return changes.map(c => ({ key: c.key, ...c.payload.val() }));
      });
  }

  fbLogin() {
    let provider = new firebase.auth.FacebookAuthProvider();

    this.auth.auth.signInWithPopup(provider)
      .then(result => this.completeProfile(result))
      .catch(error => {
        this.error = true;
        this.errorMessage = "Un usuario ya existe con ese correo electrónico";
      });
  }

  googleLogin() {
    let provider = new firebase.auth.GoogleAuthProvider();

    this.auth.auth.signInWithPopup(provider)
      .then(result => this.completeProfile(result))
      .catch(error => {
        this.error = true;
        this.errorMessage = "Un usuario ya existe con ese correo electrónico";
      });
  }

  phoneLogin() {
    let controller = this;
    let recaptchaVerifier = new firebase.auth.RecaptchaVerifier('register-button', {
      'size': 'invisible'
    });

    if (!this.user.phone.startsWith("+")) this.user.phone = "+502"+this.user.phone;
    firebase.auth().signInWithPhoneNumber(this.user.phone, recaptchaVerifier)
      .then(function(confirmationResult) {
        controller.confirmationResult = confirmationResult;
        controller.verified = true;
        controller.loading = false;
        controller.next();
      })
      .catch(function(error) {
        console.log("Awwww");
      });
  }

  trySignup() {
    if (this.user.phone && !this.user.email) {
      this.loading = true;
      this.phoneLogin();
    }
    else if(!this.social){
      this.next();
    }
    else {
      this.createProfile();
    }
  }

  signUp() {
    let controller = this;
    if (this.verified) {
      let code = this.user.code;
      this.confirmationResult.confirm(code).then(function(result) {
        let credential = firebase.auth.PhoneAuthProvider.credential(controller.confirmationResult.verificationId, code);
        controller.currentUser = result.user;
        firebase.auth().signInWithCredential(credential);
        controller.createProfile();
      })
    }
    else {
      this.loading = true;
      firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password)
        .then(result => {
          controller.currentUser = result;
          controller.loading = false;
          result.sendEmailVerification();
          result.updateProfile({
            displayName: controller.user.full_name,
            photoUrl: null
          })
          .then(result => controller.createProfile())
          .catch(err => console.log(err));
        })
    }
  }

  completeProfile(result) {
    this.currentUser = result.user;
    this.social = true;
    this.next();
  }

  next() {
    this.step = this.step + 1;
  }

  createProfile() {
    this.profile.userId = this.currentUser.uid;
    this.profile.displayName = this.currentUser.displayName || this.user.full_name;
    this.db.list('/profiles').set(this.currentUser.uid, this.profile)
    .then(result => {
      this.router.navigate(['']);
    });
  }

  setState(state) {
    this.profile.state = state.name;
  }

  setStatus(data: {value: string[]}) {
    this.profile.status = data.value;
  }

  toggleNotification(item) {
    if (!this.profile.notifications)  this.profile.notifications = [];
    const index = this.profile.notifications.indexOf(item.key);

    if ( index > -1) {
      this.profile.notifications.splice(index, 1);
    } else {
      this.profile.notifications.push(item.key);
    }
  }

  isSelected(item) {
    return this.profile.notifications ? this.profile.notifications.indexOf(item.key) !== -1 : false;
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/signup/signup-form/signup-form.component.ts